import Phaser from "phaser";
import Boot from "./view/boot.js";
import Preload from "./view/preload.js";
import Menu from "./view/menu.js";
import Quiz from "./view/quiz.js";
import BubblesIntro from "./view/bubbles-intro.js";
import Bubbles from "./view/bubbles.js";
import EndScreen from "./view/end-screen.js";
import EndScreenQuiz from "./view/end-screen-quiz.js";
import InputTextPlugin from "phaser3-rex-plugins/plugins/inputtext-plugin.js";

const config = {
  type: Phaser.CANVAS,
  width: 1510,
  height: 930,
  scene: [
    Boot,
    Preload,
    Menu,
    Quiz,
    BubblesIntro,
    Bubbles,
    EndScreen,
    EndScreenQuiz,
  ],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  parent: "divId",
  dom: {
    createContainer: !0,
  },
  physics: {
    default: "arcade",
    arcade: {
      gravity: {
        x: 0,
        y: -8,
      },
    },
  },
  plugins: {
    global: [
      {
        key: "rexInputTextPlugin",
        plugin: InputTextPlugin,
        start: true,
      },
    ],
  },
};

export default new Phaser.Game(config);
